import { render, staticRenderFns } from "./ScatterChart.vue?vue&type=template&id=5f85c614&"
import script from "./ScatterChart.vue?vue&type=script&lang=js&"
export * from "./ScatterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports